import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRevised from './App-revised';
import { initializeAppInsights } from './services/appInsightsService';

// Initialize Application Insights for distributed tracing
// Connection string is provided via environment variable
const appInsightsConnectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;
if (appInsightsConnectionString) {
  initializeAppInsights(appInsightsConnectionString);
  console.log('[Main] Application Insights initialized');
} else {
  console.log('[Main] Application Insights not configured (REACT_APP_APPINSIGHTS_CONNECTION_STRING not set)');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRevised />
  </React.StrictMode>
);